import React from 'react';


const SectionTitle = ({subtitle, title, description, textAlignment, textColor}) => {
    return (
        <div className={`section-heading ${textAlignment} ${textColor}`}>
            {subtitle ? <div className="subtitle" dangerouslySetInnerHTML={{__html: subtitle}}></div> : null}
            {title ? <h2 className="title" dangerouslySetInnerHTML={{__html: title}}></h2> : null}
            {description ? <p dangerouslySetInnerHTML={{__html: description}}></p> : null}
        </div>
    )
}

export default SectionTitle;